function SingleBanner({ item }) {
    return (
        <div className='w-full'>
            <img className='w-full h-auto' src={item.item.imageLink} alt={item.item.altText} />
        </div>
    );
}

export default SingleBanner;
